// extracted by mini-css-extract-plugin
export default {"toggle":"ProjectDetailForm_toggle__70xIy","detail":"ProjectDetailForm_detail__iVZgO"};